import { Collapse as AntCollapse } from "antd";
import classNames from "classnames";
import styles from "./collapse.module.scss";

export const Collapse = ({ compact = false, ...props }) => {
  return (
    <AntCollapse
      expandIconPosition="end"
      className={classNames(styles.collapse, {
        [styles.collapse_compact]: compact,
      })}
      {...props}
    />
  );
};

Collapse.Panel = AntCollapse.Panel;
